import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FiAlertTriangle, FiShield } from "react-icons/fi";
// import { Image } from "react-bootstrap";
const DefaultPasswordReminderModal = ({ show, handleClose, onChangePassword }) => {

  const handleCloseWithCleanup = () => {
  sessionStorage.removeItem("usingDefaultPassword");
  handleClose();
};

  return (
    <Modal
      show={show}
      onHide={handleCloseWithCleanup}
      centered
      backdrop="static"
      size="md"
    >
      {/* add close function something like 
       onClick={() => {
            sessionStorage.removeItem("usingDefaultPassword");
            handleClose();
          }} */}
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center gap-2">
          <FiShield color="#f59e0b" size={24} />
          Default Password Detected
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="text-center mb-4">
          <FiAlertTriangle
            size={54}
            color="#f59e0b"
            style={{ marginBottom: "16px" }}
          />
          {/* <Image src="/images/LOGO-07.png" alt="ReyZap CRM Logo" style={{ width: "40%" }}/> */}

          <h5 className="fw-bold mb-3">
           Your workspace was created with a default password.
          </h5>

          <p className="text-muted mb-2">
            Your workspace has been created successfully and your temporary
            administrator password was sent to your registered email address.
          </p>

          <p className="text-muted mb-0">
            For better security, we strongly recommend changing your password
            before inviting team members or continuing to use your workspace.
          </p>
        </div>

        <div
          style={{
            background: "#fff8e6",
            border: "1px solid #ffe08a",
            borderRadius: "8px",
            padding: "12px",
            fontSize: "14px",
          }}
        >
          <strong>Tip:</strong> Check your email if you don't remember your
          temporary password.
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="outline-secondary"
          onClick={() => {
            sessionStorage.removeItem("usingDefaultPassword");
            handleClose();
          }}
        >
          Remind Me Later
        </Button>

        <Button
          style={{
            background: "#164788",
            borderColor: "#164788",
          }}
          onClick={() => {
            handleClose();
              setTimeout(() => {
                  onChangePassword();
              }, 150);
          }}
        >
          Change Password
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DefaultPasswordReminderModal;